<template>
    <!-- <b-list-group-item v-for="invite in invites" :key="invite.accountInviteId" class="flex-column align-items-start"> -->
    <b-list-group-item class="flex-column align-items-start job-list-card" >
        <div class="d-flex w-100 justify-content-between">
            <h5 class="mb-1">{{roleName}} @ {{targetName}}</h5>
            <small>{{ invite.creationDate | moment("from") }}</small>
        </div>

        <p class="mb-1">
        This invite will grant <strong>{{targetName}}</strong> with <strong>{{roleName}}</strong> permissions once accepted.
        </p>

        <div class="d-flex w-100">
            <small>Invite expires {{invite.expirationDate | moment("from")}}</small>
            <div class="ml-auto">
                <b-button size="sm" variant="outline-danger" @click="revoke">Revoke</b-button>
            </div>
        </div>
    </b-list-group-item>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  components: {
  },
  props: {
    invite: {
      type: Object, // corresponds to an AccountInviteMessage
      required: true,
    },
    accountRoles: {
      type: Array, // corresponds to an AccountRole list
      required: true,
    },
    projectRoles: {
      type: Array, // corresponds to an AccountRole list
      required: true,
    },
  },
  data() {
    return {
    };
  },
  created() {
    console.log('LOADED PENDING INVITE', this.invite);
  },
  computed: {
    ...mapGetters([
      'activeProjectId',
    ]),
    roleName() {
      const accountRole = this.accountRoles.find((r) => r.roleId === this.invite.accountRole);
      if (accountRole && accountRole.roleId !== 0) {
        return accountRole.details.name;
      }
      // TODO: do we want to show a drop down of each project role if no account role here?
      // const projectRoleItem = this.invite.projectRolesList.find((r) => r.projectId === this.activeProjectId);
      // if (projectRole && projectRole.roleId !== 0) {
      //   return projectRole.details.name;
      // }
      return this.invite.projectRolesList && this.invite.projectRolesList.length > 0 ? `${this.invite.projectRolesList.length.toString()} Project` : 'None';
    },
    targetName() {
      return this.invite.email ? this.invite.email : '~Unknown User~';
    },
  },
  methods: {
    async revoke() {
      // TODO: modal confirm prompt first for reject
      console.log('revoking invite', this.invite);
      this.$emit('revoke-pending-invite', this.invite.inviteId);
    },
  },
};
</script>
<style>

</style>
